<template>
  <span class="text-no-wrap">
    <slot name="startDate" v-bind:item="item">
        {{ convertToHumanReadableDate(item.clockIn.date) }}
    </slot>
  </span>
</template>

<script>
import DateTimeUtil from '@/util/date-time-util';

export default {
  name: 'StartDateTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    convertToHumanReadableDate(dateTime) {
      return DateTimeUtil.convertToHumanReadableDate(dateTime);
    },
  },
};
</script>
